import classNames from "classnames";
import { CSSProperties } from "react";

const SpinnerSize = {
  xs: "xs",
  sm: "sm",
  md: "md",
  lg: "lg",
  xl: "xl",
} as const;

interface SpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: keyof typeof SpinnerSize;
}

const Spinner = ({ className, size = "md", style, ...props }: SpinnerProps) => {
  const cssStyles: CSSProperties = {
    borderLeftColor: "transparent",
    borderRightColor: "transparent",
    borderTopColor: "currentColor",
    borderBottomColor: "currentColor",
    ...style,
  };

  const sizeClasses: Record<keyof typeof SpinnerSize, string> = {
    xs: "w-3 h-3",
    sm: "w-5 h-5",
    md: "w-7 h-7",
    lg: "w-9 h-9",
    xl: "w-12 h-12",
  };

  return (
    <div
      className={classNames("animate-spin rounded-full border-2 border-solid", sizeClasses[size], className)}
      role="progressbar"
      style={cssStyles}
      {...props}
    ></div>
  );
};

export default Spinner;
